import { timeResponseMapper } from "../../../targetingExpression.helpers";


export const daysOfWeekOptions = [
  {
    label: "Sunday",
    value: 0,
  },
  {
    label: "Monday",
    value: 1,
  },
  {
    label: "Tuesday",
    value: 2,
  },
  {
    label: "Wednesday",
    value: 3,
  },
  {
    label: "Thursday",
    value: 4,
  },
  {
    label: "Friday",
    value: 5,
  },
  {
    label: "Saturday",
    value: 6,
  },
];

type TimeShortcutLabel =
  | "Work Hours"
  | "After work"
  | "Sleeping Time"
  | "Weekends"
  | "Prime Time";

export type TimeShortcutValue =
  | "workHours"
  | "afterWork"
  | "sleepingTime"
  | "weekends"
  | "primeTime";

type TimeShortcut = {
  label: TimeShortcutLabel;
  value: TimeShortcutValue;
};

export const timeShortcutButtons: TimeShortcut[] = [
  {
    label: "Work Hours",
    value: "workHours",
  },
  {
    label: "After work",
    value: "afterWork",
  },
  {
    label: "Sleeping Time",
    value: "sleepingTime",
  },
  {
    label: "Weekends",
    value: "weekends",
  },
  {
    label: "Prime Time",
    value: "primeTime",
  },
];

const workHours = [
  {
    comparator: "in_range",
    value: [1920, 2459] as [number, number],
  },
  {
    comparator: "in_range",
    value: [3360, 3899] as [number, number],
  },
  {
    comparator: "in_range",
    value: [4800, 5339] as [number, number],
  },
  {
    comparator: "in_range",
    value: [6240, 6779] as [number, number],
  },
  {
    comparator: "in_range",
    value: [7680, 8219] as [number, number],
  },
];

const afterWork = [
  {
    comparator: "in_range",
    value: [2460, 2639] as [number, number],
  },
  {
    comparator: "in_range",
    value: [3900, 4079] as [number, number],
  },
  {
    comparator: "in_range",
    value: [5340, 5519] as [number, number],
  },
  {
    comparator: "in_range",
    value: [6780, 6959] as [number, number],
  },
  {
    comparator: "in_range",
    value: [8220, 8399] as [number, number],
  },
];

const sleepingTime = [
  {
    comparator: "in_range",
    value: [1440, 1799] as [number, number],
  },
  {
    comparator: "in_range",
    value: [2880, 3239] as [number, number],
  },
  {
    comparator: "in_range",
    value: [4320, 4679] as [number, number],
  },
  {
    comparator: "in_range",
    value: [5760, 6119] as [number, number],
  },
  {
    comparator: "in_range",
    value: [7200, 7559] as [number, number],
  },
  {
    comparator: "in_range",
    value: [8640, 8999] as [number, number],
  },
  {
    comparator: "in_range",
    value: [0, 359] as [number, number],
  },
];

const primeTime = [
  {
    comparator: "in_range",
    value: [2640, 2819] as [number, number],
  },
  {
    comparator: "in_range",
    value: [4080, 4259] as [number, number],
  },
  {
    comparator: "in_range",
    value: [5520, 5699] as [number, number],
  },
  {
    comparator: "in_range",
    value: [6960, 7139] as [number, number],
  },
  {
    comparator: "in_range",
    value: [8400, 8579] as [number, number],
  },
  {
    comparator: "in_range",
    value: [9840, 10019] as [number, number],
  },
  {
    comparator: "in_range",
    value: [1200, 1379] as [number, number],
  },
];

const weekends = [
  {
    comparator: "in_range",
    value: [8640, 10079] as [number, number],
  },
  {
    comparator: "in_range",
    value: [0, 1439] as [number, number],
  },
];

export const getShortcutFieldValues = (value: TimeShortcutValue) => {
  switch (value) {
    case "workHours":
      return timeResponseMapper(workHours);
    case "afterWork":
      return timeResponseMapper(afterWork);
    case "sleepingTime":
      return timeResponseMapper(sleepingTime);
    case "primeTime":
      return timeResponseMapper(primeTime);
    case "weekends":
      return timeResponseMapper(weekends);
    default:
      return [];
  }
};

export const TIME_DEFAULT_VALUES = {
  startDay: null,
  endDay: null,
  startTime: null,
  endTime: null,
}
